import pako from "pako";
import { state } from "../settings";

const splitState = "config=";

export function encodeStateToURL() {
  const stateCopy = {
    ct: state.countryType,
    st: state.shapeType,
    si: state.sizeIndex,
    h: state.height,
    l: state.length,
    w: state.width,
    in: state.installation ? 1 : 0,
    it: state.anchorType === 'surface' ? 1 : 0,
    cb: state.colorBody,
    sa: [...state.subAccessoriesUrl],
    // Non-permanent placed accessories: "key:zone:spanIndex:slope"
    pl: (state.accessoryPlacements || []).map(p =>
      `${p.key}:${p.zone}:${p.span}:${p.slope ?? ''}`
    ),
    dp_mat: state.downpipeMaterial || 'grey_plastic',
  };

  const jsonString = JSON.stringify(stateCopy);
  const compressed = pako.deflate(jsonString);

  let binary = '';
  for (let i = 0; i < compressed.length; i++) {
    binary += String.fromCharCode(compressed[i]);
  }
  return btoa(binary);
}

export function decodeURLToState(encoded) {
  try {
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const decompressed = pako.inflate(bytes, { to: 'string' });
    const d = JSON.parse(decompressed);

    return {
      countryType: d.ct ?? 0,
      shapeType: d.st ?? 0,
      sizeIndex: d.si ?? 0,
      height: d.h ?? 2,
      length: d.l ?? 2,
      width: d.w ?? 4,
      installation: d.in === 1,
      anchorType: d.it === 1 ? 'surface' : 'ground',
      colorBody: d.cb ?? "#C8C8C8",
      subAccessoriesUrl: new Set([...(d.sa || []), 'downpipes']),
      accessoryPlacements: (d.pl || []).map(s => {
        const [key, zone, span, slope] = s.split(':');
        return { key, zone, span: +span, slope: slope || null };
      }),
      downpipeMaterial: d.dp_mat || 'grey_plastic',
    };
  } catch (error) {
    console.error('Error decoding state:', error);
    return {};
  }
}

export function changeURL() {
  const url = encodeStateToURL();
  const newUrl = `${window.location.origin}${window.location.pathname}?${splitState}${url}`;
  history.pushState({}, '', newUrl);
}

export function initURLSystem() {
  // 
}

export async function initStateFromUrl() {
  const urlParams = window.location.search;
  const idx = urlParams.indexOf(splitState);
  if (idx === -1) return null;

  const stateParam = urlParams.substring(idx + splitState.length);
  if (!stateParam) return null;

  try {
    const decodedState = decodeURLToState(stateParam);
    Object.assign(state, decodedState);
    return decodedState;
  } catch (error) {
    console.error('Error loading state from URL:', error);
    return null;
  }
}
